var invisibleValues = new Set(["none", "hidden"]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */

function mixVisibility(origin, target) {
  if (invisibleValues.has(origin)) {
    return function (p) {
      return p <= 0 ? origin : target;
    };
  } else {
    return function (p) {
      return p >= 1 ? target : origin;
    };
  }
}

export { invisibleValues, mixVisibility };